(function() {
    identify('config', 'google_maps.js');

    angular.module('BuscaAtivaEscolar').config(function() {});

})();